import { Alert } from '@creditornot/cb-alert';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type Props = {
  className?: string;
};

const Text = styled.p`
  margin: 0;
  & + & {
    margin-block-start: 8px;
  }
`;

const VenueRolesInfo = (props: Props) => {
  return (
    <Alert variant="info" {...props}>
      <Text>
        <FormattedMessage
          id="userManagement.info.venueManagerDescription"
          values={{
            strong: (text: string) => <strong>{text}</strong>,
          }}
        />
      </Text>
      <Text>
        <FormattedMessage
          id="userManagement.info.venueStaffDescription"
          values={{
            strong: (text: string) => <strong>{text}</strong>,
          }}
        />
      </Text>
    </Alert>
  );
};

export default VenueRolesInfo;
